import { Link } from "react-router-dom";
import type { ArchiveEvent } from "@/types/archive";
import { getCategoryName } from "@/utils/archive";

export default function ArchiveCard({ event }: { event: ArchiveEvent }) {
  return (
    <article className="group h-full flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 hover:border-primary-700 transition-colors">
      <Link to={`/archive/${event.id}`} className="block cursor-pointer">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={event.cover}
            alt={`${event.title} 事件档案配图`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs bg-background-50/85 text-primary-300 backdrop-blur-sm">
            {event.yearLabel}
          </span>
        </div>
      </Link>
      <div className="flex flex-col flex-1 p-5">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-secondary-900/40 text-secondary-200">
            <i className="ri-price-tag-3-line" aria-hidden="true"></i>
            {getCategoryName(event.category)}
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-map-pin-line" aria-hidden="true"></i>
            {event.location}
          </span>
        </div>
        <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950">
          <Link to={`/archive/${event.id}`} className="cursor-pointer hover:text-primary-400 transition-colors">
            {event.title}
          </Link>
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-500 line-clamp-3">
          {event.summary}
        </p>
        <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-time-line" aria-hidden="true"></i>
            阅读约 {event.readTime}
          </span>
          <Link
            to={`/archive/${event.id}`}
            className="cursor-pointer inline-flex items-center gap-1 text-primary-400 hover:text-primary-300 transition-colors"
          >
            查看脉络
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}